<div class="resizable-widget" [ngClass]="resizable ? 'active' : 'disabled'" (resized)="onResized($event)">
    <div echarts [autoResize]="autoResize" [options]="options" class="echarts" (chartInit)="onChartInit($event)">
    </div>
</div>

